<template>
  <v-fade-transition>
    <v-progress-linear
        v-if="isLoading"
      indeterminate
      height="4"
    ></v-progress-linear>
  </v-fade-transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FhProgress',
  computed: {
    ...mapGetters('loading', [
      'isLoading'
    ])
  }
}
</script>

<style scoped>
.v-progress-linear >>> {
  top: -2px;
}
</style>
